const WelcomeWidget = () => {
    return (
        <div className="h-full w-full p-4 bg-blue-50 rounded shadow flex flex-col justify-center items-center">
            <h2 className={"font-medium"}>Optik V2 Müşteri Yönetim Sistemi</h2>
        </div>
    );
};

export default WelcomeWidget;
